<template>
  <d-card class="card-small mb-4 pt-1">
    <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
      <i class="fa fa-info mx-2"></i>
      <span id="warning">{{ error_msg }}</span> 
    </d-alert>
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>

                <!-- Password -->
                <d-col md="6" class="form-group">
                  <label for="fePassword">Password</label>
                  <d-form-input type="password" id="fePassword" placeholder="Password" v-model="password" />
                </d-col>

                <d-col md="6" class="form-group">
                  <label for="feConfirmPassword">Confirm Password</label>
                  <d-form-input type="password" id="feConfirmPassword" placeholder="Confirm Password" v-model="confirm_password" />
                </d-col>
              </d-form-row>

              <d-button type="button" :disabled="loading" class="btn-accent" @click="update_profile">Update Password</d-button>
            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';

export default {
  components: {
    VueElementLoading,
  },
  name: 'user-account-details',
  props: {
    /**
     * The component title.
     */
    title: {
      type: String,
      default: 'Account Details',
    },
  },
  data(){
    return {
      password:'',
      confirm_password:'',
      loading:false,
      old_data:[],
      show_alert:false,
      error_msg:'',
    }
  },
  methods: {
    update_profile(){
        let formData = new FormData();
        let dthis=this;        
        if (this.password!=this.confirm_password){
            this.pop_alert("Passwords don't match");
            return;
        }
        let submit=true;
        if (submit){
          this.loading=true;
          this.axios.post( env.server+'/profile/update',{
            password:this.password
          }).then( resp=>{
            console.log(resp.data);
            this.loading=false;
            this.$store.commit('token','');
            self.location='/prayer.admin/';

          }).catch( e=>{
            this.pop_alert(JSON.parse(e.response.data));
            this.loading=false;
          });
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=5;
      this.error_msg=msg;
    },
  },
  mounted(){
  },
};
</script>
